var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen overflow-hidden m-0 p-0"},[(_vm.pictogram)?_c('ViewerPageKonva',{attrs:{"canActionsPictogram":_vm.canActionsPictogram,"pictogram":_vm.pictogram,"work-layer":_vm.workLayer},on:{"epc-reload":() => { _vm.$emit('epc-reload') },"epc-screenshot":(e) => { _vm.$emit('epc-screenshot', e) }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }